import { useState } from "react";

export default function Composer({ onSend }) {
  const [input, setInput] = useState("");

  return (
    <div style={{
        display: "flex",
        position: "sticky",
        bottom: 23,
        background: "#fff",
        paddingTop: 8,
        padding: "12px 16px",
        borderTop: "1px solid rgba(0,0,0,0.05)",
    }}>
      <textarea
        value={input}
        onChange={(e) => setInput(e.target.value)}
        placeholder="Tell me what’s worrying you…"
        rows={2}
        style={{ flex: 1, padding: 10, borderRadius: 14 }}
        onKeyDown={(e) => {
          if (e.key === "Enter" && (e.metaKey || e.ctrlKey)) {
            onSend(input);
            setInput("");
          }
        }}
      />
      <button
        onClick={() => {
          onSend(input);
          setInput("");
        }}
        style={{ marginLeft: 8, padding: "10px 16px", borderRadius: 14 }}
      >
        Send
      </button>
    </div>
  );
}